<template>
  <Loader v-if="bigLoading" />
  <div class="container-fluid" v-else>
    <div class="row">
      <div class="col">
        <form @submit.prevent="getData">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-4 col-md-12 mb-3">
                  <label class="form-label" for="picker">
                    {{ $t("gpool.form_date") }}
                  </label>
                  <date-range-picker
                    ref="picker"
                    :timePicker="true"
                    :timePicker24Hour="true"
                    :time-picker-increment="1"
                    v-model="dateRange"
                    format="dd-MM-yyyy HH:mm:ss"
                    style="display: block"
                  >
                    <template v-slot:input="picker" style="min-width: 350px">
                      {{ picker.startDate | date }} -
                      {{ picker.endDate | date }}
                    </template>
                  </date-range-picker>
                </div>
                <div class="col-lg-4 col-md-12 mb-3">
                  <label class="form-label" for="sites">
                    {{ $t("gpool.form_site") }}
                  </label>
                  <select
                    class="form-control"
                    name="sites"
                    id="sites"
                    required
                    v-model="filter.siteid"
                  >
                    <option :value="site.id" v-for="site in sites">
                      {{ site.name }} - {{ site.domain }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-auto col-md-12 mb-3">
                  <label class="form-label" for="currencies">
                    {{ $t("gpool.form_currency") }}
                  </label>
                  <select
                    class="form-control"
                    name="currencies"
                    id="currencies"
                    v-model="currencyId"
                  >
                    <option :value="0">{{ $t("gpool.form_all") }}</option>
                    <option :value="currency.id" v-for="currency in currencies">
                      {{ currency.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-3 col-md-12 mb-3">
                  <label class="form-label" for="categories">
                    {{ $t("gpool.form_category") }}
                  </label>
                  <select
                    class="form-control"
                    name="categories"
                    id="categories"
                    v-model="selected_category"
                  >
                    <option value="">
                      {{ $t("gpool.form_all") }}
                    </option>
                    <option :value="category.id" v-for="category in categories">
                      {{ category.name }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-3 col-md-12 mb-3">
                  <label class="form-label" for="companies">
                    {{ $t("gpool.form_company") }}
                  </label>
                  <select
                    class="form-control"
                    name="companies"
                    id="companies"
                    v-model="selected_company"
                    :readonly="!selected_category"
                    :disabled="!selected_category"
                  >
                    <template v-if="selected_category">
                      <option value="">
                        {{ $t("gpool.form_all") }}
                      </option>
                      <option
                        :value="company.id"
                        v-for="company in filteredCompanies"
                      >
                        {{ company.name }}
                      </option>
                    </template>
                    <option v-else selected disabled value="">
                      {{ $t("gpool.form_select_category") }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-3 col-md-12 mb-3">
                  <label class="form-label" for="games">
                    {{ $t("gpool.form_game") }}
                  </label>
                  <select
                    class="form-control"
                    name="games"
                    id="games"
                    v-model="selected_game"
                    :readonly="!selected_company"
                    :disabled="!selected_company"
                  >
                    <template v-if="selected_company">
                      <option value="">
                        {{ $t("gpool.form_all") }}
                      </option>
                      <option :value="game.id" v-for="game in filteredGames">
                        {{ game.name }}
                      </option>
                    </template>
                    <option value="" selected disabled v-else>
                      {{ $t("gpool.form_select_company") }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-1 col-md-12 mb-3">
                  <label class="form-label" for=""> &nbsp; </label>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    style="display: block"
                  >
                    <i class="fa fa-magnifying-glass"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <Loader v-if="loading" />
    <div class="row" v-show="!loading" v-if="!noData">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <div v-if="!listData.length && !player_list.length">
              {{ $t("gpool.no_data") }}
            </div>
            <template v-if="listData.length || player_list.length">
              <div class="row" v-if="player_list.length">
                <div class="col">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col text-end mb-3">
                          <button class="btn btn-success" @click="getExcel">
                            <i class="fa fa-file-excel"></i>&nbsp; Excel
                          </button>
                        </div>
                      </div>
                      <AgGridVue
                        style="height: 500px; padding: 15px"
                        class="ag-theme-alpine"
                        :columnDefs="columns"
                        :rowData="player_list"
                        :pagination="true"
                        :paginationPageSize="100"
                        @grid-ready="onGridReady"
                        @first-data-rendered="onFirstDataRendered"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table
                v-if="listData.length"
                class="table table-bordered table-striped mt-2"
              >
                <thead>
                  <tr>
                    <th>{{ $t("gpool.table_name") }}</th>
                    <th>{{ $t("gpool.table_currency") }}</th>
                    <th>{{ $t("gpool.table_in") }}</th>
                    <th>{{ $t("gpool.table_out") }}</th>
                    <th>{{ $t("gpool.table_profit") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in listData" :key="item.id">
                    <td>{{ item.name || `(${item.id})` }}</td>
                    <td>{{ item.currency || selected_currency_name }}</td>
                    <td>{{ item.in | moneyFormatter }}</td>
                    <td>{{ item.out | moneyFormatter }}</td>
                    <td>{{ item.profit | moneyFormatter }}</td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="nodata" v-else>
      {{ $t("gpool.no_data") }}
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import currencies from "../data/currencies.json";
import Loader from "../components/Loader.vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
export default {
  name: "Stats",
  components: { DateRangePicker, Loader, AgGridVue },
  filters: {
    date: function (value) {
      return moment(value).format("DD.MM.YYYY HH:mm");
    },
  },
  watch: {
    selected_category() {
      this.selected_company = "";
      this.selected_game = "";
    },
    selected_company() {
      this.selected_game = "";
    },
  },
  computed: {
    ...mapGetters("site", ["sites"]),
    ...mapGetters("category", ["categories"]),
    ...mapGetters("company", ["companies"]),
    ...mapGetters("game", ["games"]),
    ...mapGetters("total", [
      "player_list",
      "sum",
      "list",
      "loading",
      "bigLoading",
      "listData",
      "limit",
      "noData",
      "totals",
    ]),
    filteredCompanies() {
      return this.companies.filter(
        (item) => item.category_id == this.selected_category
      );
    },
    filteredGames() {
      return this.games.filter(
        (item) => item.company_id == this.selected_company
      );
    },
    selected_currency_name() {
      if (!this.currencyId) return "xxx";
      return this.currencies.find((item) => item.id == this.currencyId).name;
    },
  },
  async mounted() {
    await this.setLoading(true);
    await this.setBigLoading(true);
    await this.getSites();
    if (this.sites.length > 0) this.filter.siteid = this.sites[0].id;
    await this.getCategories();
    await this.getCompanies();
    await this.getGames();
    await this.setBigLoading(false);
    await this.getData();
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    getExcel() {
      this.api.exportDataAsCsv();
    },
    onGridReady(params) {
      this.api = params.api;
      this.columnApi = params.columnApi;
    },
    async getData() {
      this.setLoading(true);
      this.setNoData(false);
      if (
        this.selected_category &&
        this.selected_company &&
        this.selected_game
      ) {
        this.filter.providerid = this.selected_company;
        this.filter.gameid = this.selected_game;
      } else if (this.selected_category && this.selected_company) {
        this.filter.gameid = "";
        this.filter.providerid = this.selected_company;
      } else if (this.selected_category) {
        this.filter.gameid = "";
        this.filter.providerid = this.companies
          .filter((comp) => comp.category_id == this.selected_category)
          .map((a) => a.id);
      } else {
        this.filter.gameid = "";
        this.filter.providerid = "";
      }

      let postData = {
        filter: {
          ...this.dateRange,
          ...this.filter,
        },
        refs: {
          currency: this.currencyId,
          selected_category: this.selected_category,
          selected_company: this.selected_company,
          selected_game: this.selected_game,
        },
      };

      if (this.currencyId) postData.currencyId = this.currencyId;

      await this.getStatSum(postData);
    },
    ...mapActions("total", [
      "getStatSum",
      "setLoading",
      "setBigLoading",
      "setNoData",
    ]),
    ...mapActions("site", ["getSites"]),
    ...mapActions("category", ["getCategories"]),
    ...mapActions("company", ["getCompanies"]),
    ...mapActions("game", ["getGames"]),
  },
  data() {
    return {
      currencies,
      dateRange: {
        startDate: moment().subtract(7, "days").startOf("day").unix() * 1000,
        endDate: moment().endOf("day").unix() * 1000,
      },
      filter: {
        siteid: "",
        providerid: "",
        gameid: "",
      },
      selected_category: "",
      selected_company: "",
      selected_game: "",
      currencyId: 0,
      api: null,
      columnApi: null,
      columns: [
        {
          headerName: "ID",
          field: "id",
          required: true,
          suppressSizeToFit: true,
        },
        {
          headerName: this.$t("gpool.table_name"),
          field: "name",
          required: true,
          sortable: true,
        },
        {
          headerName: this.$t("gpool.table_currency"),
          field: "currency",
          required: true,
          sortable: true,
          suppressSizeToFit: true,
          cellRenderer: (row) => {
            return row.value || this.selected_currency_name;
          },
        },
        {
          headerName: this.$t("gpool.table_in"),
          field: "in",
          required: true,
          sortable: true,
          cellRenderer: (row) => {
            return Intl.NumberFormat("tr", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(row.value);
          },
          comparator: (valueA, valueB) => parseInt(valueA) - parseInt(valueB),
        },
        {
          headerName: this.$t("gpool.table_out"),
          field: "out",
          required: true,
          sortable: true,
          cellRenderer: (row) => {
            return Intl.NumberFormat("tr", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(row.value);
          },
          comparator: (valueA, valueB) => parseInt(valueA) - parseInt(valueB),
        },
        {
          headerName: this.$t("gpool.table_profit"),
          field: "profit",
          required: true,
          sortable: true,
          cellRenderer: (row) => {
            return Intl.NumberFormat("tr", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(row.value);
          },
          comparator: (valueA, valueB) => parseInt(valueA) - parseInt(valueB),
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Total.vue